import { NotificationLevels, NotificationTypes } from '@adsk/bim360-matrix-react-components';
import T from 'i18n-react';
import { getToken } from '../../utils/getToken';
import { getBlob } from '../../utils/blob-helpers';
import { downloadBlob } from '../../utils/downloadFile';
import { getPromiseForAsyncNotification } from '../../utils/notificationHelpers';
import { showNotificationAction } from '../actions';
import { getCurrentProjectScope } from '../selectors';
import { getS3DownloadUrl } from '../../utils/getS3UrlFromOss';

export default class AttachmentDownloadThunk {
  static downloadAttachment({ url, name }, asyncMessage, failureMessage) {
    return (dispatch, getState) => {
      const notificationPromise = getPromiseForAsyncNotification();
      dispatch(
        showNotificationAction({
          type: NotificationTypes.TOAST,
          level: NotificationLevels.SUCCESS,
          message: asyncMessage,
          autoDismiss: 0.5,
          asyncOperation: notificationPromise.promise,
          closeButtonTooltipText: T.translate('notifications.downloadWillContinue'),
        })
      );
      const projectScope = getCurrentProjectScope(getState());
      getToken({ getState, dispatch })
        .then((token) => getS3DownloadUrl({ url, token, projectScope }))
        .then(({ url: s3Url }) => getBlob(s3Url, 'octet/stream', null, projectScope))
        .then((blob) => {
          notificationPromise.resolve();
          downloadBlob(blob, name);
        })
        .catch(() => {
          notificationPromise.reject();
          dispatch(
            showNotificationAction({
              type: NotificationTypes.SNACKBAR,
              level: NotificationLevels.ERROR,
              message: failureMessage,
            })
          );
        });
    };
  }
}
